const getActivePeriods = (periods) =>
    periods.filter((period) => period.status === 'in_progress' || period.status === 'in_draft')

export { getActivePeriods }
